import {PathImage} from "@/types/Paths";
import {SegmentImage} from "@/types/Segments";
import {PlaceImage} from "@/types/Places";

export function useGetFeaturedImage(images: Array<PathImage | SegmentImage | PlaceImage> | undefined): PathImage | SegmentImage | PlaceImage {
  if (!images || images.length === 0) return {
    url: '/PLACEHOLDER-640x480px.jpg',
    alt_text: "",
    caption: ""
  }

  return images[0]
}
